<script>
import ActivityWidget from '../dashboard/ActivityWidget.vue';

export default {
  extends: ActivityWidget,

  methods: {
    get () {
      console.log(this.user);
      this.$http.get(`/user/${this.user.hashid}/log`)
        .then(({ data }) => {
          this.data = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
